$(document).on('click','.custom_swatches .product-variant__item',function(){ 
  var idd = $(this).find('input:checked').attr('data-variant-id'); 
  $('.shop_buy_now').attr('data-id',idd); 
});


document.addEventListener('DOMContentLoaded', function () {

  const addToCartBtns = document.querySelectorAll('#add_to_cart');
  const buyNowBtn = document.querySelectorAll('#shop_buy_now');

  // Normal Add to Cart buttons
  addToCartBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      const variantId = this.dataset.id;
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(() => {
        refreshCart();

        const originalText = this.innerText;
        this.innerText = 'ADDED ✔';
        this.classList.add('added');

        setTimeout(() => {
          this.innerText = originalText;
        }, 2000);
      })
      .catch(error => {
        console.error('Add to cart error:', error);
      });
    });
  });

  // BUY NOW button → Add to cart + redirect to checkout
  buyNowBtn.forEach(btn => {
    btn.addEventListener('click', function () {
      const variantId = this.dataset.id;
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Buy now error:', error);
      });
    });
  });

}); // ✅ properly closes first DOMContentLoaded


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".first_linklist ul li").forEach(function (li) {
    li.addEventListener("mouseover", function () {
      let value = this.getAttribute("data-img");
      let img = this.closest(".link-list")
        ?.querySelector("li.mega-link.has-promotion img");

      if (img && value && value.trim() !== "") {
        img.src = value;
        img.srcset = value;
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
    const btn = document.getElementById("CheckOut");

    if (btn) {
        btn.addEventListener("click", function () {
            window.location.href = "/checkout";
        });
    }
});



 $(document).ready(function(){
if(window.matchMedia("(max-width:767px)").matches) {
 $('.why-us__products').slick({
  slidesToShow: 1,
  infinite:true,
  arrows:true,
  centerMode: false,
  centerPadding: '40px',
   prevArrow: '<div class="slick-prev"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_122_877)"> <path d="M0.926514 14.1185L7.29047 7.75459L0.926514 1.39062" stroke="#000" stroke-width="2"/> </g> <defs> <clipPath id="clip0_122_877"> <rect width="9" height="15" fill="black"/> </clipPath> </defs> </svg></div>',
   nextArrow: '<div class="slick-next"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_122_872)"> <path d="M8.07349 14.1185L1.70953 7.75459L8.07349 1.39062" stroke="#000" stroke-width="2"/> </g> <defs> <clipPath id="clip0_122_872"> <rect width="9" height="15" fill="black" transform="matrix(-1 0 0 1 9 0)"/> </clipPath> </defs> </svg></div>',
});
}
 }) 
